<div class="selected-counter">
  {{selectedCount}} selected
</div>
<!-- Removed Header in latest AC
<div class="table-tool-header">
  <button (click)="refreshTable()" class="table-icon-button"> <img src="assets/icon/Arrow-Clockwise.svg"> </button>
</div>
-->
<table mat-table [dataSource]="dataSource" >
  <ng-container matColumnDef="Selector">
    <th mat-header-cell *matHeaderCellDef>
      @switch (allSelector) {
        @case (selectorStatusEnums.Unselected) {
          <div>
            <span [ngClass]="'select-box'"> <button (click)="selectAll()" class="table-icon-button"> <img src="assets/icon/Checkbox-Unchecked.svg"> </button> All </span>
          </div>
        }
        @case (selectorStatusEnums.Partial) {
          <div>
            <span [ngClass]="'select-box'"> <button (click)="toggleSelection()" class="table-icon-button"> <img src="assets/icon/Checkbox-Indeterminate.svg"> </button> All </span>
          </div>
        }
        @case (selectorStatusEnums.Selected) {
          <div>
            <span [ngClass]="'select-box'"> <button (click)="deselectAll()" class="table-icon-button"> <img src="assets/icon/Checkbox-Checked.svg"> </button> All </span>
          </div>
        }
      }
    </th>
    <td mat-cell *matCellDef="let element">
      @switch (element.selector) {
        @case (selectorStatusEnums.Unselected) {
          <div>
            <button (click)="selectAppointment(element.appointmentId)" class="table-icon-button"> <img src="assets/icon/Checkbox-Unchecked.svg"> </button>
          </div>
        }
        @case (selectorStatusEnums.Selected) {
          <div>
            <button (click)="deselectAppointment(element.appointmentId)" class="table-icon-button"> <img src="assets/icon/Checkbox-Checked.svg"> </button>
          </div>
        }
        @case (selectorStatusEnums.Invalid) {
          <div>
            <tooltip>
              <img subject src="assets/icon/Phone-Error.svg" (click)="deselectAppointment(element.appointmentId)">
              <span tooltip><b>Missing or Invalid number</b></span>
            </tooltip>
          </div>
        }
        @case (selectorStatusEnums.Searching) {
          <div [ngClass]="'loading-div'">
            <mat-spinner [diameter]="20"/>
          </div>
        }
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="AppointmentDate">
    <th mat-header-cell *matHeaderCellDef> Appt Date </th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.appointmentDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}}</div>
      <div>{{element.appointmentDate.toLocaleString('en-US', { day: 'numeric', month: 'numeric', year: 'numeric'})}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="PatientName">
    <th mat-header-cell *matHeaderCellDef> Patient Name </th>
    <td mat-cell *matCellDef="let element"> {{element.patientName}} </td>
  </ng-container>

  <ng-container matColumnDef="DateOfBirth">
    <th mat-header-cell *matHeaderCellDef> Date Of Birth </th>
    <td mat-cell *matCellDef="let element">
      {{element.dateOfBirth}}
    </td>
  </ng-container>

  <ng-container matColumnDef="PatientId">
    <th mat-header-cell *matHeaderCellDef> Patient ID </th>
    <td mat-cell *matCellDef="let element"> {{element.patientExternalId}} </td>
  </ng-container>

  <ng-container matColumnDef="ProviderName">
    <th mat-header-cell *matHeaderCellDef> Provider </th>
    <td mat-cell *matCellDef="let element"> {{element.provider}} </td>
  </ng-container>

  <ng-container matColumnDef="LocationName">
    <th mat-header-cell *matHeaderCellDef> Location </th>
    <td mat-cell *matCellDef="let element"> {{element.location}} </td>
  </ng-container>

  <ng-container matColumnDef="AppointmentType">
    <th mat-header-cell *matHeaderCellDef> Appt Type </th>
    <td mat-cell *matCellDef="let element"> {{element.appointmentType}} </td>
  </ng-container>

  <ng-container matColumnDef="AppointmentStatus">
    <th mat-header-cell *matHeaderCellDef> Appt Status </th>
    <td mat-cell *matCellDef="let element"> {{element.apptStatus}} </td>
  </ng-container>

  <ng-container matColumnDef="ChatStatus">
    <th mat-header-cell *matHeaderCellDef> Chat Status </th>
    <td mat-cell *matCellDef="let element">
      @switch (element.chatStatus) {
        @case (chatStatusEnums.Closed) {
          <div>
            <button (click)="previewChat(element.appointmentId)" class="table-icon-button"> <img src="assets\icon\Locked.svg"> </button>
          </div>
        }
        @case (chatStatusEnums.Open) {
          <div
            class="open-chat-icon">
            <button (click)="previewChat(element.appointmentId)" class="table-icon-button"> <img src="assets\icon\Unlocked.svg"> </button>
          </div>
        }
      }
    </td>
  </ng-container>

  <tr class="table-header-row" mat-header-row *matHeaderRowDef="displayedColumns"> </tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>